import client from "../client";

export interface TopupAngpaoResponse {
  AmountA: number;
  AmountB: number;
  AmountC: number;
  IsCredit: boolean;
}

export default function API(): Promise<TopupAngpaoResponse> {
  return client
    .post(`/gameinhouse/angpao/bet`)
    .then((response) => response.data);
}
